import type { UpdateSettingsAddReferenceKpisInput } from "../domain/settings";
import {
  fetchSettingsAPI,
  updateSettingsAddReferenceKpisAPI,
  updateSettingsDefaultReferenceAPI,
} from "../infrastructure/settings.api";
import type { Settings } from "../infrastructure/settings.formatter";

export function fetchSettings(): Promise<Settings> {
  return fetchSettingsAPI();
}

export async function updateSettingsDefaultReference({
  referenceId,
  tableId,
}: { referenceId: number; tableId: number }): Promise<void> {
  await updateSettingsDefaultReferenceAPI(referenceId, tableId);
}

export function updateSettingsAddReferenceKpis(
  input: UpdateSettingsAddReferenceKpisInput,
): Promise<void> {
  return updateSettingsAddReferenceKpisAPI(input);
}
